<template>
  <div>
    <div class="sayfahead">
      <h1>{{Sayfa.Adi}}</h1>
      <el-button v-if="Yetki" type="info" size="small" class="YeniBtn" @click="this.YeniBtn">{{Sayfa.ButtonAdi}}
      </el-button>
    </div>
    <div class="icerik">
      <div class="ekranbos" v-if="!Liste"></div>
      <el-table
        v-if="Liste"
        :data="Liste.filter(data => !search || data.Detay.BinaAdi.toLowerCase().includes(search.toLowerCase()))"
        class="golgetable">

        <el-table-column
          :label="this.$t('eYonetim.19.0')"
          prop="Tarih"
          width="120">
        </el-table-column>
        <el-table-column
          :label="this.$t('eYonetim.19.1')"
          prop="DurumText"
          width="140">
        </el-table-column>
        <el-table-column
          :label="this.$t('eYonetim.19.2')"
          prop="Detay.BinaAdi"
          width="400">
        </el-table-column>
        <el-table-column
          :label="this.$t('eYonetim.19.3')"
          prop="Detay.Fiyat"
          width="150">
        </el-table-column>
        <el-table-column
          :label="this.$t('eYonetim.19.4')"
          prop="Detay.Daire"
          width="150">
        </el-table-column>

        <el-table-column
          align="right">
          <template slot="header" slot-scope="scope">
            <el-input
              v-model="search"
              size="medium"
              :placeholder="Sayfa.Arama"/>
          </template>
          <template v-if="Yetki" slot-scope="scope">
            <el-button-group>
              <el-tooltip class="item" effect="dark" :content="Sayfa.DuzenleAdi"
                          placement="top-start">
                <el-button
                  size="mini"
                  type="primary"
                  icon="feather-edit-2"
                  @click="DuzenleBtn(scope.row)">
                </el-button>
              </el-tooltip>
              <el-tooltip class="item" effect="dark" :content="Sayfa.SilAdi"
                          placement="top-start">
                <el-button
                  size="mini"
                  type="danger"
                  icon="el-icon-delete-solid"
                  @click="SilOnay(scope.row.id)">
                </el-button>
              </el-tooltip>
            </el-button-group>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog
      v-if="Yetki"
      :title="FormData.Baslik"
      :visible.sync="ModalOlayi"
      center
      width="50%">
      <a @click="ModalOlayi = false;" class="ModalKapat"><i class="el-icon-close"></i></a>
      <el-form :model="Form" @submit.prevent.native="Submit" :rules="FormHata" ref="Form">
        <el-row :gutter="20">
          <el-col :span="18">
            <el-form-item :label="$t('eYonetim.19.5')" prop="BinaAdi">
              <el-input v-model="Form.Detay.BinaAdi"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">


            <el-form-item :label="$t('eYonetim.19.1')" prop="Durum">
              <el-select v-model="Form.Durum" filterable>
                <el-option
                  v-for="item in Durums"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item :label="$t('eYonetim.19.6')" prop="Daire">
              <el-input v-model="Form.Detay.Daire"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('eYonetim.19.7')" prop="Fiyat">
              <el-input v-model="Form.Detay.Fiyat"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item :label="$t('eYonetim.19.8')" prop="Yonetici">
              <el-input v-model="Form.Detay.Yonetici"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('eYonetim.19.9')" prop="YoneticiTelefon">
              <el-input v-model="Form.Detay.YoneticiTelefon"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <input type="hidden" v-model="Form.id">
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size="medium" @click="Submit()">{{$t('eGenel.0')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        Yetki: false,
        ModalOlayi: false,
        Durums: [
          {value: '1', label: this.$t('eYonetim.19.10')},
          {value: '2', label: this.$t('eYonetim.19.11')},
          {value: '3', label: this.$t('eYonetim.19.12')}
        ],
        Sayfa: {
          ButtonAdi: this.$t('eYonetim.16'),
          Adi: this.$t('mYonetim.9'),
          DuzenleAdi: this.$t('eGenel.10'),
          SilAdi: this.$t('eGenel.11'),
          Menu: [
            {Adi: this.$t('mYonetim.7'), Link: '/yonetim/sirket'},
            {Adi: this.$t('mYonetim.8'), Link: '/yonetim/sirket/meskenturu'}
          ],
          MenuDisplay: true,
          Arama: this.$t('eGenel.9')
        },
        search: '',
        Liste: [],
        FormData: {
          Baslik: null,
          Sil: false
        },
        FormHata: {
          Durum: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
          Detay: {
            BinaAdi: [{required: true, message: this.$t('eGenel.12'), trigger: 'blur'}],
          }


        },
        Form: {
          Durum: null,
          Detay: {
            BinaAdi: null,
            Fiyat: null,
            Yonetici: null,
            YoneticiTelefon: null,
            Daire: null
          },
          id: null
        },
        hata: {
          Tanim: null
        }
      }
    },
    methods: {
      SayfaYukle() {
        this.$store.dispatch("Get", {path: 'yonetim/sirket/teklif'})
          .then(response => {
            if (response.Durum === 'OK') {
              this.Liste = response.Liste
            } else {
              this.$message.error(response.Mesaj);
              this.hata = response.Hata;
            }
          });
        this.Yetki = this.$store.getters.Yetki.yonetim == 2 ? true : false;
      },
      DuzenleBtn(Veri) {
        this.Form = Veri;
        this.ModalOlayi = true;
        this.FormData.Baslik = this.$t('eYonetim.17')
      },
      YeniBtn() {
        this.ModalOlayi = true;
        this.FormData.Baslik = this.$t('eYonetim.16');
        this.Form = {
          Durum: null,
          Detay: {
            BinaAdi: null,
            Fiyat: null,
            Yonetici: null,
            YoneticiTelefon: null,
            Daire: null
          },
          id: null
        }

      },
      Submit() {
        this.$refs['Form'].validate((valid) => {
          if (valid) {
            if (this.Form.id) {
              // DÜZENLE
              this.$store.dispatch("Put", {
                ...this.Form,
                path: 'yonetim/sirket/teklif/' + this.Form.id
              })
                .then(response => {
                  if (response.Durum == "OK") {
                    this.ModalOlayi = false;
                    this.$message.success(response.Mesaj);
                    this.SayfaYukle();

                  } else {

                    this.$message.error(response.Mesaj);
                    this.hata = response.Hata;

                  }
                })

            } else {
              // EKLE
              this.$store.dispatch("Post", {...this.Form, path: 'yonetim/sirket/teklif'})
                .then(response => {
                  if (response.Durum == "OK") {
                    this.ModalOlayi = false;
                    this.$message.success(response.Mesaj);
                    this.SayfaYukle();
                  } else {
                    this.$message.error(response.Mesaj);
                    this.hata = response.Hata;
                  }
                })
            }
          }
        });
      },
      SilOnay(id) {
        this.$confirm(this.$t('eGenel.1'), this.$t('eGenel.7'), {
          confirmButtonText: this.$t('eGenel.2'),
          cancelButtonText: this.$t('eGenel.3'),
          type: 'warning'
        }).then(() => {
          this.Sil(id)
        }).catch(() => {
          this.$message.info(this.$t('eGenel.8'));
        });
      },
      Sil(id) {
        this.$store.dispatch("Delete", {...this.Form, path: 'yonetim/sirket/teklif/' + id})
          .then(response => {
            if (response.Durum == "OK") {
              this.ModalOlayi = false;
              this.$message.success(response.Mesaj);
              this.SayfaYukle();
            } else {
              this.$message.warning(response.Mesaj);
              this.hata = response.Hata;
            }
          })

      },
    },
    created() {
      this.$store.commit("SayfaBilgi", this.Sayfa);
      this.SayfaYukle();

      window.addEventListener('keyup', event => {
        if (event.key === this.$t('KisaYol.1')) this.YeniBtn();
      });


    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/Yonetim/sirket/Teklif.vue